import StudentFilter from "types/StudentFilter";
import { Card } from "./ui/Card";

interface GroupSummaryCardProps {
  filter: StudentFilter;
  studentCount: number;
}

export function GroupSummaryCard({
  filter,
  studentCount,
}: GroupSummaryCardProps) {
  const label = filter.subject || filter.gradeLevel;

  return (
    <Card className="space-y-1 lg:space-y-2 ml-12 lg:ml-0">
      <h2 className="text-base lg:text-lg font-bold">{label}</h2>
      <p className="text-xs lg:text-sm text-gray-600">
        {studentCount} students in this group
      </p>
    </Card>
  );
}
